export enum ViaAvoidType {
    Avoid = "Avoid",
    Via = "Via"
}
